export default __webpack_public_path__ + "static/media/357.86c8ba7b.png";